import { render, staticRenderFns } from "./gl-scoring-bar-chart-2.vue?vue&type=template&id=3fb80d6c"
import script from "./gl-scoring-bar-chart-2.vue?vue&type=script&lang=js"
export * from "./gl-scoring-bar-chart-2.vue?vue&type=script&lang=js"
import style0 from "./gl-scoring-bar-chart-2.vue?vue&type=style&index=0&id=3fb80d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports